import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type LoginVisibleType = false | "Join" | "Login";
export type ReportableType = {
  objectType: string;
  objectId: number;
  description: string;
};
export type UiStateType = {
  loginVisible?: LoginVisibleType;
  theme: "light" | "dark";
  report: null | ReportableType;
  openButtonId: string | null;
};

export const uiState: UiStateType = {
  loginVisible: false,
  theme: null,
  report: null,
  openButtonId: null,
};

export const uiSlice = createSlice({
  name: "UiSlice",
  initialState: uiState,
  reducers: {
    toggleLoginVisible(state, { payload }: { payload: LoginVisibleType }) {
      state.loginVisible = payload;
    },
    setTheme(state, { payload }: { payload: "light" | "dark" }) {
      state.theme = payload;
    },
    startReport(state, { payload }: { payload: ReportableType }) {
      state.report = payload;
    },
    endReport(state) {
      state.report = null;
    },
    setOpenDropdown: (state, action: PayloadAction<string | null>) => {
      // If clicking the same button that's already open, close it
      if (state.openButtonId === action.payload) {
        state.openButtonId = null;
      } else {
        // Otherwise, set the new button ID (closing any other open dropdown)
        state.openButtonId = action.payload;
      }
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice.reducer;
